import React, { useEffect } from "react";
import { Modal } from "react-bootstrap";
import NotificationStep from "./NotificationStep";
import { useTranslation } from "react-i18next";
import { checkStepDataType, getCheckStepData } from "../constants";
import { useReactiveVar } from "@apollo/client";
import { currentCompanyIdVar } from "@me-team/host/main/globalVar/state";
import { useGetCurrentBranchForNotificationsQuery } from "@me-team/host/main/logbook/graphql/logbook.hooks";
import { useParams } from "react-router-dom";

interface NotificationsModalProps {
    show: boolean;
    handleClose: () => void;
    title: string;
}

const NotificationsModal: React.FC<NotificationsModalProps> = ({ show, handleClose, title }) => {
    const { t } = useTranslation();
    const currentCompanyId: string = useReactiveVar(currentCompanyIdVar);
    const [checkStepData, setCheckStepData] = React.useState<checkStepDataType[]>([]);
    const { branchId } = useParams();

    const { data: branchData, loading } = useGetCurrentBranchForNotificationsQuery({
        variables: {
            companyId: Number(currentCompanyId),
            branchId: Number(branchId),
            bookingsLimit: 1,
        },
        fetchPolicy: "network-only",
    });

    useEffect(() => {
        if (branchData) {
            setCheckStepData(getCheckStepData(currentCompanyId, branchData.user.company.branches[0]));
        }
    }, [branchData, currentCompanyId]);

    if (loading) return null;

    return (
        <Modal show={show} onHide={handleClose} centered className="px-1 w-100">
            <Modal.Header closeButton className="border-0 align-items-center">
                <Modal.Title className="h5">{t(title)}</Modal.Title>
            </Modal.Header>
            <Modal.Body className="text-center pb-4">
                <div className="px-6  d-flex flex-column gap-3">
                    {checkStepData?.map((step: checkStepDataType) => (
                        <NotificationStep key={step.id} checkStepData={step} />
                    ))}
                </div>
            </Modal.Body>
        </Modal>
    );
};

export default NotificationsModal;
